import { DONATION_FREQUENCY, PAYMENT_METHOD_TYPE } from '@types';
import { t } from 'i18next';

export const tPaymentMethod = (p: PAYMENT_METHOD_TYPE) => {
  switch (p) {
    case PAYMENT_METHOD_TYPE.STRIPE:
      return t('Credit card');
    case PAYMENT_METHOD_TYPE.MANUAL:
      return t('Manual');
    case PAYMENT_METHOD_TYPE.PAYPAL:
      return t('PayPal');
  }
};

export const tDonationFrequency = (f: DONATION_FREQUENCY) => {
  switch (f) {
    case DONATION_FREQUENCY.ONEOFF:
      return t('once');
    case DONATION_FREQUENCY.MONTHLY:
      return t('monthly');
    // case DONATION_FREQUENCY.BIMONTHLY:
    //   return t('bi-monthly');
    // case DONATION_FREQUENCY.THREE_MONTHLY:
    //   return t('three-monthly');
    // case DONATION_FREQUENCY.FOUR_MONTHLY:
    //   return t('four-monthly');
    // case DONATION_FREQUENCY.SEMIANNUAL:
    //   return t('semi-annual');
    // case DONATION_FREQUENCY.ANNUAL:
    //   return t('yearly');
  }
};
